export enum AutoDimensionType {
  AUTO_DIMENSION_FLOOR_PLAN_EXTERIOR_BY_ROOM_MULTIPLE = "AUTO_DIMENSION_FLOOR_PLAN_EXTERIOR_BY_ROOM_MULTIPLE",
  AUTO_DIMENSION_FLOOR_PLAN_EXTERIOR_BY_ROOM_SINGLE = "AUTO_DIMENSION_FLOOR_PLAN_EXTERIOR_BY_ROOM_SINGLE",
  AUTO_DIMENSION_FLOOR_PLAN_EXTERIOR_BY_ORIENTATION = "AUTO_DIMENSION_FLOOR_PLAN_EXTERIOR_BY_ORIENTATION",

  AUTO_DIMENSION_FOUNDATION_EXTERIOR_BY_ROOM_MULTIPLE = "AUTO_DIMENSION_FOUNDATION_EXTERIOR_BY_ROOM_MULTIPLE",
  AUTO_DIMENSION_FOUNDATION_EXTERIOR_BY_ROOM_SINGLE = "AUTO_DIMENSION_FOUNDATION_EXTERIOR_BY_ROOM_SINGLE",
  AUTO_DIMENSION_FOUNDATION_EXTERIOR_BY_ORIENTATION = "AUTO_DIMENSION_FOUNDATION_EXTERIOR_BY_ORIENTATION",

  AUTO_DIMENSION_FOUNDATION_INTERIOR_BY_ROOM_MULTIPLE = "AUTO_DIMENSION_FOUNDATION_INTERIOR_BY_ROOM_MULTIPLE",
  AUTO_DIMENSION_FOUNDATION_INTERIOR_BY_ROOM_SINGLE = "AUTO_DIMENSION_FOUNDATION_INTERIOR_BY_ROOM_SINGLE",
  AUTO_DIMENSION_FOUNDATION_INTERIOR_BY_ORIENTATION = "AUTO_DIMENSION_FOUNDATION_INTERIOR_BY_ORIENTATION",

  AUTO_DIMENSION_FLOOR_PLAN_INTERIOR_BY_OPPOSITE_ROOM_EDGE_PAIR = "AUTO_DIMENSION_FLOOR_PLAN_INTERIOR_BY_OPPOSITE_ROOM_EDGE_PAIR",
  AUTO_DIMENSION_FLOOR_PLAN_INTERIOR_BY_ORTHOGONAL_ROOM_EDGE = "AUTO_DIMENSION_FLOOR_PLAN_INTERIOR_BY_ORTHOGONAL_ROOM_EDGE",
}
